'use es6';

const SHOULD_USE_JSON = [{
  idSchema: /^(?:post|patch)-\/cms\/v\d\/blog/m,
  models: ['BlogPost']
}, {
  idSchema: /^(?:post|patch)-\/cms\/v\d\/pages/m,
  models: ['Page']
}];
export default SHOULD_USE_JSON;